import { PDFDocument } from "pdf-lib";

export interface IMergePdfsOptions {
  /**
   * Wydruk dwustronny: każdy dokument zaczyna się na nowej kartce — po dokumencie
   * o nieparzystej liczbie stron dokładana jest pusta strona (w Magistracie każde pismo
   * szło osobnym zadaniem drukarki, więc problem nie występował).
   */
  duplex?: boolean;
}

const toBytes = async (file: Blob | ArrayBuffer | Uint8Array) => {
  if (file instanceof Uint8Array) return file;
  if (file instanceof ArrayBuffer) return new Uint8Array(file);
  return new Uint8Array(await file.arrayBuffer());
};

/** Scala PDF-y w jeden dokument do jednego zadania wydruku. */
export const mergePdfs = async (
  files: (Blob | ArrayBuffer | Uint8Array)[],
  options: IMergePdfsOptions = {}
): Promise<Blob> => {
  const output = await PDFDocument.create();

  for (const file of files) {
    const source = await PDFDocument.load(await toBytes(file), {
      ignoreEncryption: true,
    });
    const pages = await output.copyPages(source, source.getPageIndices());
    pages.forEach((page) => output.addPage(page));

    if (options.duplex && pages.length % 2 === 1) {
      const { width, height } = pages[pages.length - 1].getSize();
      output.addPage([width, height]);
    }
  }

  const bytes = await output.save();
  return new Blob([bytes], { type: "application/pdf" });
};

/** Liczba stron PDF-a (podsumowanie zadania wydruku). */
export const countPdfPages = async (file: Blob | ArrayBuffer | Uint8Array) => {
  const doc = await PDFDocument.load(await toBytes(file), { ignoreEncryption: true });
  return doc.getPageCount();
};
